import { Titles } from '@/types/cate-graphql-generated-types'

export default function getTranslatedTitle(titles: Titles[] = [], language: Locale): string {
  const translatedTitle = titles?.find((d) => d.language?.toLowerCase() === language?.toLowerCase())
  if (translatedTitle && translatedTitle?.text) {
    return translatedTitle.text
  }
  return titles.length === 0 ? '' : titles[0]?.text ?? ''
}
